import { FolderOpenIcon } from 'foundations-assets/icons/components/FolderOpenIcon';
import { SearchIcon } from 'foundations-assets/icons/components/SearchIcon';
import { ServiceIcon } from 'foundations-assets/icons/components/ServiceIcon';
import { TagIcon } from 'foundations-assets/icons/components/TagIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import unescapedText from 'I18n/utils/unescapedText';
import { getPartnerTierContent } from '../../utils/getPartnerTierContent';
import { buildCatalogServiceUrl, buildCategoryUrl, buildCollectionUrl, buildListingUrl, buildSearchUrl, buildSolutionsPartnerUrl } from './navigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function mapAutocompleteItem(acCard, pathname) {
  if (acCard.resultType === 'LISTING') {
    const listing = acCard.listing.card;
    const partnerTierContent = getPartnerTierContent(listing);
    if (partnerTierContent) {
      return {
        base: acCard,
        id: String(listing.listingId),
        image: /*#__PURE__*/_jsx(Image, {
          src: listing.iconUrl,
          blockSize: "32px",
          borderRadius: "100",
          objectFit: "contain"
        }),
        subtitle: /*#__PURE__*/_jsxs(_Fragment, {
          children: [partnerTierContent.icon && /*#__PURE__*/_jsx(IconHolder, {
            icon: partnerTierContent.icon,
            padding: "0",
            verticalAlign: "text-bottom",
            marginInlineEnd: "50"
          }), partnerTierContent.text]
        }),
        url: buildSolutionsPartnerUrl(listing.slug)
      };
    } else {
      // app or agent
      return {
        base: acCard,
        id: String(listing.listingId),
        image: /*#__PURE__*/_jsx(Image, {
          src: listing.iconUrl,
          blockSize: "32px",
          borderRadius: "100"
        }),
        subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.listing', {
          displayTagLabel: listing.displayTagLabel,
          companyName: listing.companyName
        }),
        url: buildListingUrl(listing.slug)
      };
    }
  }
  if (acCard.resultType === 'QUERY') {
    const query = acCard.query;
    return {
      base: acCard,
      id: `${acCard.resultType} ${acCard.term} ${String(query.queryType)}`,
      image: /*#__PURE__*/_jsx(SearchIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      url: buildSearchUrl(acCard, pathname)
    };
  }
  if (acCard.resultType === 'CATALOG_SERVICE') {
    var _acCard$catalogServic;
    return {
      base: acCard,
      id: `${acCard.resultType} ${(_acCard$catalogServic = acCard.catalogService) === null || _acCard$catalogServic === void 0 ? void 0 : _acCard$catalogServic.catalogServiceId}`,
      image: /*#__PURE__*/_jsx(ServiceIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.catalogService'),
      url: buildCatalogServiceUrl(acCard)
    };
  }
  if (acCard.resultType === 'CATEGORY') {
    const category = acCard.category;
    return {
      base: acCard,
      id: `${acCard.category} ${String(category.categories[0])}`,
      image: /*#__PURE__*/_jsx(TagIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.category'),
      url: buildCategoryUrl(acCard)
    };
  }
  if (acCard.resultType === 'COLLECTION') {
    const collection = acCard.collection;
    return {
      base: acCard,
      id: String(collection.collectionId),
      image: /*#__PURE__*/_jsx(FolderOpenIcon, {
        size: "400",
        color: "icon-core-subtle"
      }),
      subtitle: unescapedText('marketplaceStorefront.searchBar.searchGroup.collection'),
      url: buildCollectionUrl(acCard)
    };
  }
  throw new Error(`Unknown AutocompleteCard resultType ${String(acCard.resultType)}`);
}